<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Dedication</span></p>
<p class="P_WFP_BodyText"> </p>
<p class="P_WFP_BodyText__And__Italic__And__Centre_Alignment"><span>To Auntie Fran and Uncle Errol, with love.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?58c02dc0